import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames'
import { Link } from 'react-router-dom';
import { toggleMenu } from 'cityads-v3/actions/menu';
import { RootState } from 'cityads-v3/types/reducer';
import { useTheme } from '@material-ui/core';
import classes from './Header.scss';

import IconButton from '@material-ui/core/IconButton';
import MenuOutlinedIcon from '@material-ui/icons/MenuOutlined';
import HeaderToolbar from './HeaderToolbar';
import HeaderNav from './HeaderNav';

const LOGO = require('cityads-v3/static/images/logo.svg')
const LOGO_DARK = require('cityads-v3/static/images/logoDark.svg')

type HeaderProps = {
  className?: string,
  slogan?: string
}

export default function Header({
  className,
  slogan,
  ...props
}: HeaderProps): JSX.Element {
  const theme = useTheme()
  const isDark = theme.palette.type === 'dark'
  const showHeader = useSelector((state: RootState) => state.header.showHeader)

  if (!showHeader) {
    return null;
  }

  return (
    <header
      id="header"
      className={classNames(
        classes.header,
        className,
        {
          [classes.isDark]: isDark
        }
      )}
    >
      <div className={classes.header__topline}>

        <MenuIcon />

        <Link
          className={classes.header__logoLink}
          to="/"
        >
          <img className={classes.header__logo} alt="CityAds" src={isDark ? LOGO_DARK : LOGO} />
        </Link>

        {slogan ? <div className={classes.header__slogan}>{slogan}</div> : null}

        <HeaderToolbar />
      </div>

      <HeaderNav {...props} />

    </header>
  )
}

function MenuIcon() {
  const dispatch = useDispatch()
  const isMobile = useSelector((state: RootState) => state.app.isMobile)

  const handleOpenMenu = useCallback((docked: boolean = false) => (evt: React.MouseEvent) => {
    evt.preventDefault()
    dispatch(toggleMenu(true, docked));
  }, [dispatch])

  if (isMobile) {
    return (
      <IconButton
        onClick={handleOpenMenu(false)}
        onContextMenu={handleOpenMenu(true)}
      >
        <MenuOutlinedIcon />
      </IconButton>
    );
  }

  return null;
}
